import { atom } from "recoil";
import { Building } from "../../store/modules/manager/manager.types";

export const currentMarkersState = atom({
  key: "currentMarkersState", // unique ID (with respect to other atoms/selectors)
  default: [] as Building[], // default value (aka initial value)
});
